import React from 'react';
import { Icon } from 'antd-mobile';
import './index.less';

interface ISprops {
    [propsName: string]: any;
}
const Empty = (props: ISprops) => {
    return (
        <div className="loading-wrapper">
          <div className='loading-content'>
          <Icon className="loading-icon" type="loading" />
          <div className='loading-title'>{props?.title || '加载中...'}</div>
          </div>

        </div>
    );
};
export default Empty;
